import { PLAN_LIMIT_BILLING_PATH } from './plan-limit-notice'

/**
 * The one plain sentence for a plan payment that did not go through, and the Billing path its button goes to. The
 * API serves what it is about, and the portal's banner and Billing page both say it in these words, so they never
 * drift apart.
 */

/** What the portal's past-due banner is about: whether the plan's last payment failed, and the plan by its name. */
export interface PaymentNoticeState {
    pastDue: boolean
    /** The plan by its product name ("Starter"). */
    plan: string
}

export interface PaymentNotice {
    sentence: string
    buttonLabel: 'Billing'
    /** The portal path the button goes to: the Billing page. */
    buttonPath: string
}

/**
 * What a person is told when the plan's last payment did not go through, or null when it did. `canPay` is whether
 * their access includes Billing: without it the words say who to tell, so nobody is told to do what they cannot.
 */
export function paymentNotice(state: PaymentNoticeState, canPay = true): PaymentNotice | null {
    if (!state.pastDue) {
        return null
    }
    const happened = `The last payment for the ${state.plan} plan did not go through. It will be tried again. If it cannot be collected, the plan ends and this company returns to Free.`
    return {
        sentence: canPay ? happened : `${happened} Tell the owner of this company.`,
        buttonLabel: 'Billing',
        buttonPath: PLAN_LIMIT_BILLING_PATH,
    }
}
